export interface ResponseResult<T> {
  result: T;
}
